import React, { useMemo } from "react";

// components
import Typography from "../../base-components/Typography";
import Button from "../../base-components/Button";
import Tile from "../../components/Tile";
import Card from "../../components/Card";
import { ReactComponent as Zuragu } from "../../assets/icons/zuragu-logo.svg";
import { ReactComponent as CheckCircle } from "../../assets/icons/check-circle-2.svg";
import { formatDateToYYMMDDHHMMSS } from "../../utils/helper";
import useStore2 from "../../store/hook";

export default function ThankYou() {
  const vehicleInfo = useStore2.useVehicleInfo();

  // A client-side tracking code the user can quote to support — not a
  // backend case ID (no such correlation exists yet), but real and specific
  // to this submission rather than a generic "thanks" with nothing to hold on to.
  const reference = useMemo(() => {
    const stamp = formatDateToYYMMDDHHMMSS("Asia/Ulaanbaatar");
    const plate = vehicleInfo?.plateNumber?.replace(/\s+/g, "") || "XXXXX";
    return `ZUR-${plate}-${stamp.slice(0, 10)}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleReset = () => {
    sessionStorage.clear();
    window.location.href = "/";
  };

  return (
    <div className="absolute inset-0 flex overflow-y-auto">
      <div className="flex flex-col items-center w-full gap-8 px-4 pt-16 pb-8 my-auto">
        <Zuragu className="h-10" />

        <div className="flex flex-col items-center gap-4 scale-up">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-success-soft">
            <CheckCircle stroke="#0E8C4A" className="h-8 w-8" />
          </div>
          <div className="text-center space-y-1">
            <Typography variant="Title" size="lg">
              Мэдээлэл амжилттай илгээгдлээ
            </Typography>
            <Typography className="text-black-64">
              Биднийг сонгосонд баярлалаа. Танд амжилт хүсье.
            </Typography>
          </div>
        </div>

        <Card className="w-full my-0">
          <Typography variant="Title" size="sm" className="text-black-64 mb-2">
            Хураангуй
          </Typography>
          {vehicleInfo?.plateNumber && (
            <Tile field="Улсын дугаар" value={vehicleInfo.plateNumber} />
          )}
          <Tile field="Лавлагаа дугаар" value={reference} className="border-none" />
        </Card>

        <Typography size="sm" className="text-center text-black-64">
          Асуух зүйл гарвал дээрх лавлагаа дугаараа мэдэгдээрэй.
        </Typography>

        <Button className="w-full" onClick={handleReset}>
          Нүүр хуудас руу буцах
        </Button>
      </div>
    </div>
  );
}
